import React, { Component } from 'react';
import { List, Divider, Button } from 'semantic-ui-react'
import * as moment from 'moment';
import axios from 'axios'
import { firebaseAuth, serverIp, getOrderKey, pythonApiIp, logComponentLoad } from '../../../../config/constants';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import * as UiConsts from '../../../../config/UiConstants';

class RemoveSalesPersonLeadList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            algoliaUser: '',
            salesPeopleCanGetLeadsList: [],
            loading: false
        }
    }

    componentDidMount() {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "RemoveSalesPersonLeadList");
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.perms.includes("sales")) {
            this.getList();
        }
    }

    // getSalesPeopleDropdown() {
    //     console.log("salx1 +++++++++: getArtistInfo");
    //     axios.post(serverIp + 'salesApp/getSalesPeople', {
    //         apiKey: "123123"
    //     })
    //         .then((response) => {
    //             console.log("salx12:" + JSON.stringify(response.data, null, 3));
    //             this.setState({
    //                 loading: false,
    //                 salesPeopleChoices: response.data.dropdownItems
    //             })
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             this.setState({
    //                 loading: false
    //             })
    //         });
    // }

    getList = () => {
        console.log("mk1 ++++++++++++++ getList");

        this.setState({
            loading: true
        })

        axios.post(serverIp + 'salesApp/getSalesPeopleLeadList', {
            apiKey: "getSalesPeopleLeadList",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log(response.data);
                this.setState({ loading: false });
                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({
                        loading: false,
                        salesPeopleCanGetLeadsList: response.data.salesPeopleCanGetLeadsList
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    removeJose = () => {
        console.log("mk1 ++++++++++++++ removeJose:");

        this.changeSalesPerson("remove")
    }

    addJose = () => {
        console.log("mk1 ++++++++++++++ addJose:");

        this.changeSalesPerson("add")
    }

    changeSalesPerson = (action) => {
        console.log("mk1 ++++++++++++++ changeSalesPerson: action:" + action);

        this.setState({ loading: true });

        axios.post(serverIp + 'salesApp/addRemoveSalesPersonFromLeads', {
            apiKey: "addRemoveSalesPersonFromLeads",
            action: action,
            salesPerson: "josephinenassali30@gmail.com",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log(response.data);
                this.setState({ loading: false });
                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.getList();
                    alert(response.data.message)

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }



    render() {

        const mainButton = this.state.salesPeopleCanGetLeadsList.includes("josephinenassali30@gmail.com")
            ? <Button fluid color='red' onClick={this.removeJose}>REMOVE JOSE</Button>
            : <Button fluid color='green' onClick={this.addJose}>ADD JOSE</Button>

        const rows = this.state.salesPeopleCanGetLeadsList.length > 0
            ? this.state.salesPeopleCanGetLeadsList.map((item) =>

                <h3 key={item}>
                    {item}
                </h3>
            )
            : ''


        const wholeUi = this.state.algoliaUser
            && this.state.algoliaUser != ''
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("sales")
            ? <div>
                <Divider horizontal>{'REMOVE FROM LEAD LIST'}</Divider>

                {mainButton}

                <Divider horizontal>{'LIST THAT CAN GET LEADS'}</Divider>
                {rows}

            </div>
            : ''


        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default RemoveSalesPersonLeadList;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Sales/RemoveSalesPersonLeadList.js